import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  // CircularProgress,
  Box,
  Typography
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";

export default function Debounce({
  apiKey,
  onPlaceSelected,
  options,
  placeholder,
  backgroundColor,
  color
}) {
  const {
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = useGoogle({ apiKey, options });

  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  // 🔥 SAME logic (cleaned)
  const handleSelect = (value) => {
    if (!value) return;

    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    service.getDetails(
      {
        placeId: value.place_id,
        fields: ["address_components", "formatted_address", "geometry"],
      },
      (place, status) => {
        if (status !== window.google.maps.places.PlacesServiceStatus.OK) return;

        const components = {};
        place.address_components?.forEach((comp) => {
          comp.types.forEach((type) => {
            components[type] = comp.long_name;
          });
        });

        const addressDetails =
          value.structured_formatting?.main_text ||
          value.description ||
          "";

        const postalCode = components.postal_code || "";
        const city =
          components.locality ||
          components.sublocality ||
          components.administrative_area_level_2 ||
          "";

        const province = components.administrative_area_level_1 || "";
        const country = components.country || "";

        const formattedAddress = [
          addressDetails,
          postalCode,
          city,
          province,
          country,
        ]
          .filter(Boolean)
          .join(", ");

        const addr = {
          address_details: addressDetails,
          postal_code: postalCode,
          city,
          province,
          country,
          full_address: formattedAddress,
          lat: place.geometry?.location?.lat(),
          lng: place.geometry?.location?.lng(),
        };

        onPlaceSelected?.(addr);
        setInputValue(formattedAddress);
      }
    );
  };

  return (
    <Autocomplete
      freeSolo
      options={placePredictions}
      getOptionLabel={(option) => option.description || ""}
      loading={isPlacePredictionsLoading}
      value={value}
      fullWidth
      inputValue={inputValue}

      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        getPlacePredictions({ input: newInputValue });

        if (newInputValue === "") {
          onPlaceSelected(null);
        }
      }}

      onChange={(event, newValue) => {
        setValue(newValue);
        handleSelect(newValue);
      }}

      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <LocationOnIcon fontSize="small" />
          <Typography variant="body2">
            {option.description}
          </Typography>
        </Box>
      )}

      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          size="small"
          multiline
          // minRows={1}
          maxRows={2}
          sx={{
            backgroundColor: backgroundColor || "inherit",
            "& input": {
              color: color || "inherit",
              fontSize: "14px",
            },
            // "& .MuiOutlinedInput-root": {
            //   borderRadius: "20px", // 🔥 chat style
            // },
          }}
        //   InputProps={{
        //     ...params.InputProps,
        //     endAdornment: (
        //       <>
        //         {isPlacePredictionsLoading && (
        //           <CircularProgress size={16} />
        //         )}
        //         {params.InputProps.endAdornment}
        //       </>
        //     ),
        //   }}
        />
      )}
    />
  );
}